webpackJsonp([94916293918715],{

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(47);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(65);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _bloomer = __webpack_require__(25);
	
	var _hero = __webpack_require__(49);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _erpnextModule = __webpack_require__(570);
	
	var _erpnextModule2 = _interopRequireDefault(_erpnextModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var domains = [{
	  title: 'Accounting',
	  description: 'Invoice and maintain reports and statements',
	  icon: 'coins'
	}, {
	  title: 'Human Resources',
	  description: 'Manage payroll and maintain Employee trainings',
	  icon: 'users'
	}, {
	  title: 'Manufacturing',
	  description: 'Handle Production Orders and maintain BOMs',
	  icon: 'industry'
	}, {
	  title: 'Services',
	  description: 'Manage projects and schedule maintenance',
	  icon: 'handshake'
	}, {
	  title: 'Retail',
	  description: 'Point-of-Sale and handle Purchase and Sales Orders',
	  icon: 'store'
	}, {
	  title: 'Inventory',
	  description: 'Manage warehouse and forecast stock levels',
	  icon: 'shipping-fast'
	}, {
	  title: 'Education',
	  description: 'Manage classes and fees and grade students',
	  icon: 'book'
	}, {
	  title: 'Agriculture',
	  description: 'Plan and manage crops and husbandry',
	  icon: 'seedling'
	}, {
	  title: 'Health',
	  description: 'Handle patient records and book appointments',
	  icon: 'briefcase-medical'
	}, {
	  title: 'Non-Profit',
	  description: 'Manage volunteers and handle events',
	  icon: 'hands'
	}];
	
	var ERPNext = function ERPNext(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'libermatic. - ERPNext'
	      ),
	      _react2.default.createElement('meta', {
	        name: 'description',
	        content: 'ERPNext is a leading business management software which supports industries related to retail, services, manufacturing, hospitals and clinics, schools, agriculture and non-profits'
	      })
	    ),
	    _react2.default.createElement(
	      _hero2.default,
	      data.heroImage,
	      _react2.default.createElement(
	        _bloomer.Title,
	        null,
	        'ERPNext'
	      )
	    ),
	    _react2.default.createElement(
	      _bloomer.Container,
	      { className: _erpnextModule2.default.section },
	      _react2.default.createElement(
	        _bloomer.Content,
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'As the application is a cloud service, all that you need is a modern browser. Even a smart phone or a tablet would be enough for some. You are not required to install anything and all your data would be accessible from any secure internet enabled device.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _bloomer.Container,
	      { className: _erpnextModule2.default.section },
	      _react2.default.createElement(
	        _bloomer.Columns,
	        null,
	        _react2.default.createElement(
	          _bloomer.Column,
	          { isSize: '1/4' },
	          _react2.default.createElement(
	            _bloomer.Content,
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              'What is ERPNext'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _bloomer.Column,
	          { className: _erpnextModule2.default.content },
	          _react2.default.createElement(
	            _bloomer.Content,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'ERPNext an extremely easy to use, powerful open sourced application is published by',
	              ' ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://frappe.io/' },
	                'Frappe Technologies Pvt Ltd'
	              ),
	              '. You can read more about it at',
	              ' ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://erpnext.org' },
	                'https://erpnext.org'
	              ),
	              '. They also provide their own services and support independently of ours.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'ERPNext is one of the cheapest, most easily implemented software of this type today. It can easily be integrated into your existing processes with minimal disruption to your business.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'ERPNext is highly extensible. We also provide customization option for your industry and build add ons for applications custom to your domain.'
	            )
	          ),
	          _react2.default.createElement(
	            _bloomer.Button,
	            {
	              isColor: 'primary',
	              to: '/services/pricing',
	              render: function render(props) {
	                return _react2.default.createElement(_gatsbyLink2.default, props);
	              }
	            },
	            'See Pricing'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _bloomer.Container,
	      { className: _erpnextModule2.default.section },
	      _react2.default.createElement(
	        'div',
	        { className: _erpnextModule2.default.pointers },
	        domains.map(function (_ref2) {
	          var icon = _ref2.icon,
	              title = _ref2.title,
	              description = _ref2.description;
	          return _react2.default.createElement(
	            'div',
	            { key: title },
	            _react2.default.createElement(_bloomer.Icon, { className: 'fas fa-' + icon + ' fa-3x ' + _erpnextModule2.default.icon }),
	            _react2.default.createElement(
	              'dl',
	              null,
	              _react2.default.createElement(
	                'dt',
	                null,
	                title
	              ),
	              _react2.default.createElement(
	                'dd',
	                null,
	                description
	              )
	            )
	          );
	        })
	      )
	    )
	  );
	};
	ERPNext.propTypes = {
	  data: _propTypes2.default.shape({
	    heroImage: _propTypes2.default.object
	  }).isRequired
	};
	
	exports.default = ERPNext;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 570:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"section":"src-pages-services----erpnext-module---section---1w3KH","content":"src-pages-services----erpnext-module---content---1rxQy","smallCaps":"src-pages-services----erpnext-module---smallCaps---TPves","pointers":"src-pages-services----erpnext-module---pointers---3bhuE","icon":"src-pages-services----erpnext-module---icon---3OWUr"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-erpnext-js-daed893e231e9710e926.js